module.exports = __webpack_public_path__ + "static/img/happy.413b21e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happy.jpg
// module id = 840
// module chunks = 0